import { Button, Card, Icon, Typography } from '@bharatpe/bharat-ui';
import React from 'react';
import { ArrowForwardIos } from '@bharatpe/bharat-ui';
import { IUserBank } from 'types';
interface Props {
	bank: IUserBank;
	reclaimStatus?: boolean;
	activateAccount?: (bankData: IUserBank) => void;
	onHandleClick: (bankAccountId: string, isPrimary: boolean) => void;
}

const BankItemList: React.FC<Props> = ({ bank, reclaimStatus, activateAccount, onHandleClick }) => {
	return (
		<Card
			className="p4 flex flex-column mb4"
			onClick={() => (reclaimStatus ? null : onHandleClick(bank?.bank_account_id, bank?.is_primary))}>
			<div className="flex flex-row flex-justify flex-center">
				<div className="flex flex-row flex-justify flex-center">
					<div className="br3 grey-border p2 mr3">
						<img src={bank?.bank_logo} loading="lazy" height={32} width={32} />
					</div>
					<div>
						<Typography variant="SemiBold200" className="text-left">
							{bank?.['acc-provider-name']}
						</Typography>
						<Typography variant="Light100" className="text-left grey mt1">
							a/c **** **** {bank?.account.slice(-4)}
						</Typography>
						{bank?.is_primary && (
							<div className="success-light-background flex-inline px1 br1">
								<Typography variant="Regular100" className="success text-center">
									PRIMARY
								</Typography>
							</div>
						)}
					</div>
				</div>
				{reclaimStatus ? (
					<Button
						icon={ArrowForwardIos}
						iconPosition="end"
						variant="outlined"
						className="width-33"
						onClick={() => activateAccount && activateAccount(bank)}>
						Reclaim
					</Button>
				) : (
					<Icon className="mr1 grey" icon={ArrowForwardIos} width={12} height={12} />
				)}
			</div>
		</Card>
	);
};
export default BankItemList;
